import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { Runtime } from "@silvertours/front-entities";
import { PageLegacy, PageNavigationLegacy, SupportInfoLegacy, Suppliers, AppInstallBanner, useShowAppBanner } from "@silvertours/front-features";
import { ContentModules } from "./ContentModules";
var Body = function(param) {
    var title = param.title, breadcrumbs = param.breadcrumbs, content = param.content, suppliers = param.suppliers, stage = param.stage, _includeSearch = param.includeSearch, includeSearch = _includeSearch === void 0 ? true : _includeSearch;
    var language = Runtime.useLocale().language;
    var ref = useShowAppBanner(language), isShowing = ref.isShowing, onClose = ref.onClose;
    return /*#__PURE__*/ _jsxs(PageLegacy.PageContentBase, {
        children: [
            stage,
            /*#__PURE__*/ _jsx(Suppliers.Suppliers, {
                title: title,
                suppliers: suppliers.content,
                includeSearch: includeSearch
            }),
            /*#__PURE__*/ _jsx(PageNavigationLegacy.Breadcrumbs, {
                breadcrumbs: breadcrumbs.links
            }),
            /*#__PURE__*/ _jsx(ContentModules, {
                content: content
            }),
            /*#__PURE__*/ _jsx(SupportInfoLegacy.ContactUs, {}),
            /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        id: "fglayer",
                        role: "application"
                    }),
                    /*#__PURE__*/ _jsx(AppInstallBanner, {
                        isShowing: isShowing,
                        onClose: onClose
                    })
                ]
            })
        ]
    });
};
export { Body };
